import { render, staticRenderFns } from "./RuleColorCalibration.vue?vue&type=template&id=01f78989&scoped=true&"
import script from "./RuleColorCalibration.vue?vue&type=script&lang=js&"
export * from "./RuleColorCalibration.vue?vue&type=script&lang=js&"
import style0 from "./RuleColorCalibration.vue?vue&type=style&index=0&id=01f78989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f78989",
  null
  
)

export default component.exports